<template>
  <div>
    <div v-for="(item, key) in quickBars" :key="key" class="link-item brush-item">
      <div class="link-item-name" @click="goHelpCenter(item)">
        <div class="link-item-image">
          <img :src="item.image" alt="">
        </div>
        <div class="link-item-text">
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleTokenUrl, handleHelpCenterLink } from '@/utils/tool'

export default {
  data() {
    return {
      quickBars: [],
      licenseId: 16229799
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    }
  },
  watch: {
    quickBars() {
      if (this.quickBars.length) {
        this.checkTokenUrl(this.licenseId)
      }
    }
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.quickBars = this.$store.state.brand.quickBars.filter((item) => {
          return item.type === 'web'
        })
      }, 1000)
    })
  },
  mounted() {
    window.__lc = window.__lc || {}
    window.__lc.license = this.licenseId

    ;(function(n, t, c) {
      function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: '2.0', on: function() { i(['on', c.call(arguments)]) }, once: function() { i(['once', c.call(arguments)]) }, off: function() { i(['off', c.call(arguments)]) }, get: function() { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(['get', c.call(arguments)]) }, call: function() { i(['call', c.call(arguments)]) }, init: function() {
        var n = t.createElement('script'); n.async = !0; n.type = 'text/javascript'; n.src = 'https://cdn.livechatinc.com/tracking.js'; t.head.appendChild(n)
      } }; !n.__lc.asyncInit && e.init(); n.LiveChatWidget = n.LiveChatWidget || e
    }(window, document, [].slice))

    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case 'minimized':
          LiveChatWidget.call('hide')
          break
        case 'hidden':
          break
      }
    }

    // Wait for LiveChatWidget to be ready before setting up events and hiding
    LiveChatWidget.on('ready', () => {
      LiveChatWidget.on('visibility_changed', onVisibilityChanged)
      LiveChatWidget.call('hide')
    })
  },
  methods: {
    goHelpCenter(item) {
      const isGuest = !this.token
      const user = this.$store.state.user
      const userInfo = this.$store.state.user.memberInfo
      const vipInfo = this.$store.state.user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, item, user, userInfo, vipInfo, dateFormatter)
    },
    checkTokenUrl(licenseId) {
      let url = new URL(this.quickBars[0].url)
      // Update the pathname with the dynamic licenseId
      url.pathname = `/licence/${licenseId}/v2/open_chat.cgi`
      // If there's a token, handle it
      if (this.token) {
        // Assuming handleTokenUrl is a function that adds the token to the URL
        url = new URL(handleTokenUrl(url.toString(), this.token))
      }
      // Update the quickBars array with the new URL
      this.quickBars[0].url = url.toString()
      this.$store.commit('SET_URLINFO_CSURL', this.quickBars[0].url)
    }
  }

}
</script>

